import React from 'react';

interface HouseIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const HouseIcon: React.FC<HouseIconProps> = ({ 
  size = 32, 
  color = '#4D4D4D',
  className 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M4 12L16 2.66667L28 12M6.66667 9.33333V26.6667C6.66667 27.403 7.26362 28 8 28H13.3333M25.3333 9.33333V26.6667C25.3333 27.403 24.7364 28 24 28H18.6667M13.3333 28V21.3333C13.3333 20.597 13.9303 20 14.6667 20H17.3333C18.0697 20 18.6667 20.597 18.6667 21.3333V28M13.3333 28H18.6667" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};
